export default "__VITE_ASSET__CzcE2v2O__"